export const FETCH_SUPPLIERS = 'FETCH_SUPPLIERS';
export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS';
export const FETCH_DESTINATIONS = 'FETCH_DESTINATIONS';
export const CLEAR_VSX_FILTERS = 'CLEAR_VSX_FILTERS';
